import type { CustomerWarehouseConfiguration, User, Warehouse, WarehouseWithLabel } from './contexts/UserContext';

export function getWarehouseLabelFromConfiguration(
    user: User,
    customerWarehouseConfiguration: CustomerWarehouseConfiguration
) {
    if (user?.role === 'SHIPPER' && customerWarehouseConfiguration?.warehouseNameForShipper) {
        return customerWarehouseConfiguration?.warehouseNameForShipper;
    }
    if (user?.role === 'PROVIDER' && customerWarehouseConfiguration?.warehouse?.reference) {
        return customerWarehouseConfiguration?.warehouse?.reference;
    }
    return `${customerWarehouseConfiguration?.warehouse?.address?.city} - ${customerWarehouseConfiguration?.warehouse?.address?.zipCode}`;
}

export function getWarehouseLabel(user: User, warehouse: Warehouse, defaultMessage: string = '') {
    if (!warehouse) {
        return defaultMessage;
    }

    const customerWarehouseConfiguration = user?.customerWarehouseConfigurations?.find(
        (node) => node?.warehouseId === warehouse?.id
    );
    if (user?.role === 'SHIPPER' && customerWarehouseConfiguration?.warehouseNameForShipper) {
        return customerWarehouseConfiguration?.warehouseNameForShipper;
    }

    if (user?.role === 'PROVIDER' && warehouse.reference) {
        return warehouse.reference;
    }

    if (!warehouse.address) {
        return defaultMessage;
    }

    const { city, zipCode, name } = warehouse.address;
    return [city, zipCode, name].filter((value) => !!value).join(' - ');
}

export function getWarehouseLabelFromId(user: User, warehouseId: string, defaultMessage: string = '') {
    if (!warehouseId) {
        return defaultMessage;
    }

    const warehouse = user.warehouses.find((node) => node.id === warehouseId);
    return warehouse?.label || defaultMessage;
}

export function getWarehouseAddress(warehouse: WarehouseWithLabel, defaultMessage: string) {
    return `${warehouse?.address?.addressLine1 ?? defaultMessage}, ${warehouse?.address?.zipCode ?? defaultMessage} ${
        warehouse?.address?.city ?? defaultMessage
    }`;
}
